import PropTypes from 'prop-types'
import React from 'react'
import tts from '../../lib/TTS.js'
import { connect } from 'react-redux'
import LogoHeader from '../../components/LogoHeader/LogoHeader'
import CarouselList from '../../components/CarouselList/CarouselList.js'
import Description from '../../components/FocusableDiv/FocusableDiv'
import ScrollingTextModal from '../../components/ScrollingTextModal/ScrollingTextModal'
import focusable from '../../components/Focusable/Focusable'
import Passport from '../../components/Icons/Passport/Passport'
import passportImg from '../../assets/img/passportLogo.svg'
import PlayButton from '../../components/Icons/PlayButton/PlayButton'
import Preview from '../../components/Icons/Preview/Preview'
import ProgressBar from '../../components/ProgressBar'
import StdButton from '../../components/StdButton/StdButton.js'
import Checkmark from '../../components/Icons/Checkmark/Checkmark'
import MoreEpisodesImage from '../../assets/img/moreEpisodes@2x.svg'
import Add from '../../components/Icons/Add/Add'
import Spinner from '../../components/Spinner/Spinner.js'
import VppaModal from '../../components/VppaModal/VppaModal'
import ErrorModal from '../../components/ErrorModal/ErrorModal'
import { registerUser, checkPassportStatus } from '../../actions/userActions'
import * as UI from '../../lib/ui'
import { store } from '../../store'
import {
  addToWatchList,
  removeFromWatchList,
  getVideoDetails,
  getWatchlist,
  getAllWatchlist,
} from '../../actions/contentActions'
import {
  addMore,
  removeParam,
  secondsToHms,
  secondsToTTS,
  formatContentRating,
  stripHttpProtocol,
  truncate,
  triggerSentryError,
  generateErrorData,
  platformTransitionStyle,
  ComcastErrorType,
  noOp,
  platformStoreGet,
  isValidDistributorForInAppDonations,
  getQueryParam,
} from '../../../../shared/helpers.js'
import {
  activateTemporarySetting,
  TEMPORAL_SETTINGS_AVAILABLE,
} from '../../lib/utils.js'
import { deeplinked } from '../../components/Deeplink'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import { isDonationActiveOrPastDue } from '../../actions/tvaultActions.js'
import Platform from '../../platforms'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

const PLAY_BUTTON = 'playButton'
const DESCRIPTION_TEXT = 'descriptionText'
const DESCRIPTION_MODAL = 'descriptionModal'
const WATCHLIST_BUTTON = 'watchlistButton'
const PREVIEW_BUTTON = 'previewButton'
const MORE_EPISODES_BUTTON = 'moreEpisodesButton'
const CAROUSEL_LIST = 'carouselList'
const CAROUSEL_ITEM = 'carouselItem'

class VideoDetailScreen extends React.Component {
  constructor(props) {
    super(props)
    const { location } = this.props.router
    const availability = getQueryParam(location.search, 'availability')
    this.state = {
      id: 'VideoDetailScreen',
      carouselFocused: false,
      hasFocus: false,
      descriptionModalVisible: false,
      spinnerVisible: true,
      isPlayable: false,
      vppaModalVisibility: false,
      errorVisible: false,
      unactivatedPassport: false,
      isActiveOrPastDueDonation: false,
      availability,
      enableGoingBack: false,
    }

    this.focusedIndex = 0

    this.descriptionModal = null
    this.donationInformation = null
    this.donationFeatureEnabled =
      COMCAST_IN_APP_DONATIONS_ENABLED && COMPILING_FOR_COMCASTX1
  }

  focusOnScreen(callback) {
    const focusOnScreen = new Promise((resolve) => {
      UI.setFocusedComponent(this.state.id)
      resolve()
    })

    focusOnScreen.then(() => {
      callback()
    })
  }

  componentDidMount() {
    Platform.reportAppReady()
    const params = this.props.router.params.url
    if (params === this.props.id) {
      const videoDetails = this.props.videoDetails
      if (!videoDetails.isPlayable && this.donationFeatureEnabled) {
        this.updateContent(params)
      } else {
        this.focusOnScreen(() => {
          this.setState(
            {
              spinnerVisible: false,
              vppaModalVisibility: false,
            },
            () => {
              this.setItemFocus(PLAY_BUTTON)
              tts.pushTextToRead(this.ttsIntroduction(videoDetails))
            }
          )
        })

        this.updateGoogleAnalytics(
          videoDetails.showTitle,
          videoDetails.episodeTitle
        )
        this.checkWatchList()
      }
    } else {
      this.focusOnScreen(noOp)
      this.updateContent(params)
    }

    UI.registerFocusableComponent({ screen: this.state.id })
    UI.setSidePanelVisibility(false)

    if (this.donationFeatureEnabled) {
      this.setActiveOrPastDueDonationState()
    }
  }

  checkWatchList() {
    if (this.props.watchlist === null) {
      getWatchlist(this.props.UID)
    } else if (
      this.props.videoDetails === null ||
      this.props.watchlist === 'error'
    ) {
      return
    } else {
      const isInWatchList = this.isInWatchList(
        this.props.watchlist,
        this.props.videoDetails.videoId
      )
      if (isInWatchList || this.props.watchlistFullyLoaded) {
        this.setState({
          isInWatchList,
        })
      } else {
        getAllWatchlist(this.props.UID)
      }
    }
  }

  updateContent(params) {
    const url = removeParam('station_id', decodeURIComponent(params))

    this.setState({ spinnerVisible: true })
    getVideoDetails(url)
      .then((videoDetails) => {
        store.dispatch({
          type: 'SET_VIDEO_DATA',
          payload: { id: params, videoDetails },
        })

        this.updateGoogleAnalytics(
          videoDetails.showTitle,
          videoDetails.episodeTitle
        )
        if (videoDetails.isPlayable) {
          this.setState(
            {
              spinnerVisible: false,
              isPlayable: true,
            },
            () => {
              this.setItemFocus(PLAY_BUTTON)

              tts.pushTextToRead(this.ttsIntroduction(videoDetails))
            }
          )
        } else {
          this.setState(
            {
              spinnerVisible: false,
            },
            () => {
              this.setItemFocus(WATCHLIST_BUTTON)
              this.checkVppaAgreement(videoDetails)
            }
          )
        }
      })
      .catch((error) => {
        const errorObj = generateErrorData(error)

        store.dispatch({
          type: 'TRIGGER_ERROR',
          payload: {
            error: {
              ...errorObj,
              content: {
                errorPath: this.props.router.location.pathname,
              },
              codeBaseLocation: 'VideoDetailScreen - updateContent',
              errorType: ComcastErrorType.network,
            },
          },
        })

        this.props.router.navigate('/error', { replace: true })
      })
  }

  isInWatchList(watchlist, videoId) {
    return !!watchlist?.find((y) => y.cid === videoId)
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.watchlist !== this.props.watchlist &&
      Array.isArray(this.props.watchlist)
    ) {
      if (!prevState.isInWatchList) {
        this.checkWatchList()
      }
      this.setState({
        isInWatchList: this.isInWatchList(
          this.props.watchlist,
          this.props.videoDetails.videoId
        ),
      })
    }

    if (this.props.router.params.url !== prevProps.router.params.url) {
      this.setState(
        {
          spinnerVisible: true,
        },

        () => {
          this.updateContent(this.props.router.params.url)
        }
      )
    }

    if (this.state.vppaModalVisibility !== prevState.vppaModalVisibility) {
      if (!this.state.vppaModalVisibility) {
        this.setItemFocus(PLAY_BUTTON)

        tts.pushTextToRead(this.ttsIntroduction(this.props.videoDetails))
      }
    }

    if (prevProps.pid !== this.props.pid) {
      const params = this.props.router.params.url
      this.updateContent(params)
    }

    if (prevProps.id !== this.props.id && this.props.id) {
      this.checkWatchList()
    }
  }

  ttsIntroduction(videoDetails) {
    const {
      showTitle,
      episodeTitle,
      formattedOrdinals,
      duration,
      content_rating,
      description_long,
    } = videoDetails
    const hasCaptions =
      videoDetails.captionTracks && videoDetails.captionTracks[0] ? true : false

    return `
        ${showTitle}.
        ${episodeTitle}.
        ${formattedOrdinals}.
        ${secondsToTTS(duration)}.
        ${formatContentRating(content_rating)}.
        ${hasCaptions ? 'closed captions available.' : ''}
        ${truncate.apply(description_long, [100, true])}.
        `
  }

  componentWillUnmount() {
    tts.stopRead()
  }

  updateGoogleAnalytics(showTitle, episodeTitle) {
    /* const videoPageString = `Video Page | ${showTitle} | ${episodeTitle}`
    window.ga('set', 'dimension1', this.props.callSign)
    window.ga('set', 'dimension2', this.props.UID)
    window.ga('set', 'dimension3', this.props.deviceModel)
    window.ga('send', 'pageview', videoPageString) */

    googleAnalytics4.sendPageViewEvent(
      `Video Details | ${showTitle} | ${episodeTitle}`
    )
  }

  toggleWatchlist = () => {
    const {
      assetMezzanine,
      contentType,
      contentUrl,
      duration,
      episodeTitle,
      is_mvod,
      seconds_watched,
      showTitle,
      slug,
      videoId,
      parent,
    } = this.props.videoDetails
    const videoInfo = `${showTitle} | ${episodeTitle} | ${videoId} | ${contentType}`

    /* window.ga('send', {
      hitType: 'event',
      eventCategory: 'Video Details page',
      eventAction: 'Save to Watchlist',
      eventLabel: videoInfo,
    }) */
    if (this.state.isInWatchList) {
      removeFromWatchList(videoId)
        .then(() => {
          tts.addTextToRead('Removed from My List')
          this.setState({ isInWatchList: false })
        })
        .catch((err) => {
          this.setState({
            errorVisible: true,
            errorModalTitle:
              'There was an error removing this video from your Watchlist.',
            errorButtons: [
              {
                label: 'Go Back',
                name: 'goBackButton',
                onClick: () => {
                  this.toggleErrorModal(WATCHLIST_BUTTON)
                },
              },
            ],
          })

          const errorDescription = `Error ${
            err.status ? err.status : '(unknown)'
          } removing video ${videoInfo} from watchlist`

          triggerSentryError(
            'removeFromWatchList',
            'VideoDetailScreen.js',
            {
              errorMessage: err.message ?? 'Undefined error message (default)',
              errorDescription,
              errorLocation: 'VideoDetailScreen - removeFromWatchList',
            },
            true
          )
        })
    } else {
      addToWatchList({
        cid: videoId,
        images: {
          'asset-mezzanine-16x9': assetMezzanine,
        },
        item_type: 'video',
        flags: { is_mvod },
        duration,
        seconds_watched,
        slug,
        title: episodeTitle,
        url: contentUrl,
        video_type: contentType,
        parent,
      })
        .then(() => {
          tts.addTextToRead('Added to My List')
          this.setState({ isInWatchList: true })
        })
        .catch((err) => {
          this.setState({
            errorVisible: true,
            errorModalTitle:
              'There was an error adding this video to your Watchlist.',
            errorButtons: [
              {
                label: 'Go Back',
                name: 'goBackButton',
                onClick: () => {
                  this.toggleErrorModal(WATCHLIST_BUTTON)
                },
              },
            ],
          })

          const errorDescription = `Error ${
            err.status ? err.status : '(unknown)'
          } adding video ${videoInfo} to watchlist`

          triggerSentryError(
            'addToWatchList',
            'VideoDetailScreen.js',
            {
              errorMessage: err.message ?? 'Undefined error message (default)',
              errorDescription,
              errorLocation: 'VideoDetailScreen - addToWatchList',
            },
            true
          )
        })
    }
  }

  /**
   * Allows user to dismiss the error modal
   */
  toggleErrorModal = (buttonToFocus) => {
    this.setState((prevState) => {
      return {
        errorVisible: !prevState.errorVisible,
      }
    })

    this.setItemFocus(buttonToFocus)
  }

  toggleErrorModalBound = this.toggleErrorModal.bind(this)

  setRefs = (name) => (component) => {
    if (null !== component) {
      this[name] = component
    }
  }

  setItemFocus(name) {
    const { expired, description_long } = this.props.videoDetails
    let localName = name
    if (name === PLAY_BUTTON) {
      if (this[PLAY_BUTTON]) {
        localName = PLAY_BUTTON
      } else {
        localName = WATCHLIST_BUTTON
      }
      if (expired) {
        localName = WATCHLIST_BUTTON
      }
    } else if (name === DESCRIPTION_TEXT) {
      if (description_long?.length > 0) {
        tts.addTextToRead([
          truncate.apply(description_long, [100, true]),
          'press enter to hear the full description',
        ])
      }
    }
    this[localName]?.setFocus()

    this.setState({
      carouselFocused: CAROUSEL_LIST === localName,
    })
  }

  onKeyEvent(key) {
    let handled = false
    const focusedComponent = window.focusedComponent
    const componentType = focusedComponent.componentType

    if ('undefined' !== typeof componentType) {
      tts.stopRead()
      switch (componentType) {
        case CAROUSEL_ITEM:
          if ('UP' === key) {
            this.setItemFocus(PLAY_BUTTON)
            handled = true
          }
          break

        case DESCRIPTION_TEXT:
          if ('DOWN' === key) {
            this.setItemFocus(PLAY_BUTTON)
            handled = true
          }
          if ('ENTER' === key) {
            this.setState({
              descriptionModalVisible: true,
            })
            handled = true
          }
          if ('BACK' === key) {
            if (this.state.descriptionModalVisible === false) {
              handled = false
            } else {
              handled = true
            }
          }
          break

        case DESCRIPTION_MODAL:
          if ('DOWN' === key) {
            handled = true
          }
          if ('ENTER' === key) {
            handled = true
          }
          if ('BACK' === key) {
            this.setState({
              descriptionModalVisible: false,
            })
            this.setItemFocus(DESCRIPTION_TEXT)
            handled = true
          }
          break

        case PLAY_BUTTON:
          if ('DOWN' === key) {
            this.setItemFocus(CAROUSEL_LIST)
            handled = false
          }

          if ('UP' === key) {
            this.setItemFocus(DESCRIPTION_TEXT)
            handled = true
          }
          if ('RIGHT' === key) {
            this.setItemFocus(WATCHLIST_BUTTON)
            handled = true
          }
          break
        case WATCHLIST_BUTTON:
          if ('LEFT' === key) {
            this.setItemFocus(PLAY_BUTTON)
            handled = true
          }

          if ('RIGHT' === key) {
            if (typeof this.previewButton !== 'undefined') {
              this.setItemFocus(PREVIEW_BUTTON)
              handled = true
            } else {
              this.setItemFocus(MORE_EPISODES_BUTTON)
              handled = true
            }
          }

          if ('DOWN' === key) {
            this.setItemFocus(CAROUSEL_LIST)
            handled = false
          }

          if ('UP' === key) {
            this.setItemFocus(DESCRIPTION_TEXT)
            handled = true
          }
          break

        case PREVIEW_BUTTON:
          if ('LEFT' === key) {
            this.setItemFocus(WATCHLIST_BUTTON)
            handled = true
          }

          if ('RIGHT' === key) {
            this.setItemFocus(MORE_EPISODES_BUTTON)
            handled = true
          }

          if ('DOWN' === key) {
            this.setItemFocus(CAROUSEL_LIST)
            handled = false
          }

          if ('UP' === key) {
            this.setItemFocus(DESCRIPTION_TEXT)
            handled = true
          }
          break
        case MORE_EPISODES_BUTTON:
          if ('LEFT' === key) {
            if (typeof this.previewButton !== 'undefined') {
              this.setItemFocus(PREVIEW_BUTTON)
              handled = true
            } else {
              this.setItemFocus(WATCHLIST_BUTTON)
              handled = true
            }
          }

          if ('DOWN' === key) {
            this.setItemFocus(CAROUSEL_LIST)
            handled = false
          }

          if ('UP' === key) {
            this.setItemFocus(DESCRIPTION_TEXT)
            handled = true
          }
          break

        default:
          break
      }

      if ('BACK' === key && handled === false) {
        // Take user back to screen before the error occurred or to the root in the case of deeplinking.
        if (
          deeplinked() ||
          this.props.upNextVideoToggled ||
          this.props.upNextContinueWatchingBackUrl !== '/'
        ) {
          if (this.props.searchQuery !== '') {
            store.dispatch({
              type: 'SAVE_SEARCH_QUERY',
              payload: { searchQuery: '' },
            })
          }

          if (this.props.upNextContinueWatchingBackUrl !== '/') {
            store.dispatch({
              type: 'SET_UPNEXTCONTINUEWATCHING_BACKURL',
              payload: { upNextContinueWatchingBackUrl: '/' },
            })
          }

          if (deeplinked()) {
            store.dispatch({
              type: 'DEEPLINK_URL',
              payload: {
                deeplinkedTo: false,
              },
            })
          }

          this.props.router.navigate('/home')
        } else {
          const { state: locationState } = this.props.router.location

          if (
            locationState?.fromVOD &&
            !(
              locationState?.fromContinueWatchingModal ||
              locationState?.fromUpNext
            )
          ) {
            this.props.router.navigate(-1)
          } else if (
            locationState?.fromContinueWatchingModal ||
            locationState?.fromUpNext
          ) {
            if (this.state.enableGoingBack) {
              this.props.router.navigate(-1)
            } else {
              this.setState({ enableGoingBack: true })
            }
          } else {
            this.props.router.navigate(-1)
          }
        }
        handled = true
      }
    }

    if ('DOWN' === key) {
      this.focusedIndex = 1
    }

    if ('UP' === key) {
      this.focusedIndex = 0
    }

    return handled
  }

  checkVppaAgreement = (video) => {
    const { isPlayable, isPlayableExplanation } = video

    if (isPlayable === false) {
      const mvault_id = platformStoreGet('mvault_id')
      if (mvault_id) {
        this.setState({ unactivatedPassport: true }) // The user may have an in process Passport activation
        this.setItemFocus(PLAY_BUTTON)
      } else if (isPlayableExplanation) {
        let vppa_status = false

        isPlayableExplanation.forEach((item) => {
          if (item === 'vppa_status') {
            vppa_status = true
          }
        })
        if (vppa_status && this.props.validPassport) {
          this.setState({
            vppaModalVisibility: true,
          })
        } else {
          this.setItemFocus(PLAY_BUTTON)
        }
      }
    }
  }

  toggleIsPlayable = (bool) => {
    this.setState({ isPlayable: bool })
  }

  closeModalHandler = () => {
    this.setState((prevState) => ({
      vppaModalVisibility: !prevState.vppaModalVisibility,
    }))
  }

  onAcceptHandler = () => {
    try {
      activateTemporarySetting(TEMPORAL_SETTINGS_AVAILABLE.VPPA)
      this.setState({ spinnerVisible: true }, () =>
        this.updateContent(this.props.router.params.url)
      )
      /*  window.ga('send', {
        hitType: 'event',
        eventCategory: 'VPPA renewal screen',
        eventLabel: this.props.memberships.join(','),
        eventAction: 'Confirm',
      }) */
      this.toggleIsPlayable(true)
      this.closeModalHandler()
    } catch (error) {
      triggerSentryError('acceptVPPA', 'VppaModal.js', {
        errorMessage: error.message ?? 'Undefined error message (default)',
        errorLocation: 'VppaModal - Accept VPPA',
      })
    }
  }

  declineAnywaysHandler = () => {
    registerUser(this.props.UID)
      .then(() => {
        /* let memberships = this.props.memberships.map((x) => x.short_common_name)

        //report VPPA decline
        window.ga('send', {
          hitType: 'event',
          eventCategory: 'VPPA renewal screen',
          eventLabel: memberships.join(','),
          eventAction: 'Decline Anyway',
        }) */

        this.closeModalHandler()
        this.toggleIsPlayable(false)
      })
      .catch((err) => {
        triggerSentryError('declineVppa', 'VppaModal.js', {
          errorMessage: err.message ?? 'Undefined error message (default)',
          errorLocation: 'VppaModal - Decline VPPA',
        })
      })
  }

  setModalRef = (name) => (component) => {
    if (null !== component) {
      this[name] = component
      this[name]?.setFocus()
    }
  }

  async setActiveOrPastDueDonationState() {
    try {
      const isActiveOrPastDueDonation = await isDonationActiveOrPastDue()

      this.setState({
        isActiveOrPastDueDonation,
      })
    } catch (error) {
      this.handleDonationError(error)
      this.setState({
        isActiveOrPastDueDonation: false,
      })
    }
  }

  handleDonationError(error) {
    triggerSentryError('Getting active donations', 'VideoDetailScreen.js', {
      errorMessage: error.message || 'Error getting donation information',
      errorType: ComcastErrorType.network,
    })
  }

  render() {
    const {
      carouselFocused,
      descriptionModalVisible,
      errorButtons,
      errorModalMessage,
      errorModalTitle,
      errorVisible,
      isInWatchList,
      spinnerVisible,
      vppaModalInfo,
      vppaModalVisibility,
      isActiveOrPastDueDonation,
      unactivatedPassport,
      availability,
    } = this.state

    const {
      assetMezzanine,
      captionTracks,
      collections,
      content_rating,
      description_long,
      duration,
      episodeTitle,
      expire_date,
      expired,
      formattedOrdinals,
      funderMessage,
      hasRelated,
      is_mvod,
      isPlayable,
      parentShowSlug,
      relatedAssetUrl,
      relatedAssetVideoType,
      seconds_watched,
      showTitle,
      url,
    } = this.props.videoDetails
    let newSecondsWatched = seconds_watched

    // TODO: refactor button variables to just use typical JSX hierarchy and components (for example, the playButton and <PlayButton> can be combined.)
    if (spinnerVisible)
      return (
        <div className="spinner-container">
          <Spinner visible={true} screen={true} />
        </div>
      )

    let buttons = []

    if (!expired) {
      const validPassport = this.props.validPassport || !is_mvod
      let checkButtonType
      let checkButtonLabel
      const watchedPercent = (seconds_watched / duration) * 100
      let redirectTo
      const passportUpsellUrl = `/passport-upsell/${this.props.callSign}?video=${this.props.router.params.url}`
      const donationCampaignNavigation = this.props.stationHasDonationCampaign
        ? `/in-app-donations${this.props.donationQueryParams ?? ''}`
        : passportUpsellUrl
      const playbackUrl = `/video-playback/${encodeURIComponent(this.props.id)}`
      if (validPassport && isPlayable) {
        redirectTo = playbackUrl
      } else if (unactivatedPassport) {
        redirectTo = '/passport-activation'
      } else if (
        this.donationFeatureEnabled &&
        isValidDistributorForInAppDonations(this.props.distributor) &&
        !isActiveOrPastDueDonation
      ) {
        redirectTo = donationCampaignNavigation
      } else {
        redirectTo = passportUpsellUrl
      }

      if ((validPassport && isPlayable) || unactivatedPassport) {
        if (seconds_watched < 30 || watchedPercent > 95) {
          newSecondsWatched = 0
          checkButtonType = 'play'
          checkButtonLabel = 'Play'
        } else {
          checkButtonType = 'resume'
          checkButtonLabel = 'Resume'
        }
      } else {
        checkButtonType = 'upsell'
        checkButtonLabel = `Get Passport`
      }

      let playButton = {
        id: PLAY_BUTTON,
        type: checkButtonType,
        label: checkButtonLabel,
        link: true,
        url: redirectTo,
      }

      if (unactivatedPassport || (!this.props.validPassport && is_mvod)) {
        playButton.link = false
        playButton.onClick = async () => {
          const passportActivationStatus = await checkPassportStatus(
            this.props.callSign
          )
          if (passportActivationStatus === 'PENDING') {
            this.props.router.navigate('/passport-activation', {
              state: {
                stationTitle: this.props.stationShortCommonName,
              },
            })
          } else if (passportActivationStatus === 'ACTIVATED') {
            this.props.router.navigate(playbackUrl)
          } else {
            this.props.router.navigate(redirectTo, {
              state: {
                stationTitle: this.props.stationShortCommonName,
              },
            })
          }
        }
      }

      if (
        'rejected' === this.props.vppa_status &&
        is_mvod &&
        this.props.validPassport
      ) {
        playButton.link = false
        playButton.onClick = () => {
          this.setState({
            vppaModalVisibility: true,
          })
        }
      } else if (url === '') {
        playButton.link = false
        playButton.onClick = () => {
          this.setState({
            errorVisible: true,
            errorModalTitle:
              'There was an issue loading this Video, could not determine source url.',
            errorButtons: [
              {
                label: 'Go Back',
                name: 'goBackButton',
                onClick: () => {
                  this.toggleErrorModal(PLAY_BUTTON)
                },
              },
            ],
          })
        }
      }

      if (availability !== 'not_yet_available') {
        buttons.push(playButton)
      }
    }

    let watchlistButton = {
      id: WATCHLIST_BUTTON,
      type: isInWatchList ? 'in-watchlist' : 'add-to-watchlist',
      label: 'My List',
      link: false,
      onClick: this.toggleWatchlist,
    }

    buttons.push(watchlistButton)

    if (hasRelated) {
      let relatedItemUrl = `${encodeURIComponent(relatedAssetUrl)} `

      if ('full_length' === relatedAssetVideoType) {
        relatedItemUrl = `/video-details/${relatedItemUrl}`
      } else {
        relatedItemUrl = `/video-playback/${relatedItemUrl} `
      }

      let previewButton = {
        id: PREVIEW_BUTTON,
        type: 'preview',
        label:
          'full_length' === relatedAssetVideoType ? 'Full Episode' : 'Preview',
        link: true,
        url: relatedItemUrl,
      }

      buttons.push(previewButton)
    }
    if (this.props.videoDetails.parent?.resource_type !== 'franchise') {
      const parentItemUrl = `/show-details/${parentShowSlug}`
      const moreEpisodesButton = {
        id: MORE_EPISODES_BUTTON,
        type: 'moreEpisodes',
        label: 'More Episodes',
        link: true,
        url: parentItemUrl,
      }
      buttons.push(moreEpisodesButton)
    }

    return vppaModalVisibility ? (
      <VppaModal
        closeModalHandler={this.closeModalHandler}
        visible={vppaModalVisibility}
        componentType="vppaModal"
        onAcceptHandler={this.onAcceptHandler}
        declineAnywaysHandler={this.declineAnywaysHandler}
        ref={this.setModalRef('vppaModal')}
      />
    ) : (
      <div className="video-detail-screen-container">
        <div className="spinner-container">
          <Spinner visible={spinnerVisible} screen={true} />
        </div>
        {errorVisible && (
          <ErrorModal
            title={errorModalTitle}
            description={errorModalMessage}
            buttons={errorButtons}
            componentType="errorModal"
            visible={errorVisible}
            toggle={this.toggleErrorModalBound}
            hideStationLogo={true}
            ref={this.setModalRef('errorModal')}
          />
        )}
        {descriptionModalVisible ? (
          <ScrollingTextModal
            parent={this}
            center={true}
            visible={descriptionModalVisible}
            title={episodeTitle}
            content={description_long}
            componentType="descriptionModal"
            ref={this.setModalRef(DESCRIPTION_MODAL)}
          />
        ) : null}

        {!spinnerVisible && (
          <>
            <div
              className="video-detail-screen"
              style={{
                transition: platformTransitionStyle(
                  'transform 400ms ease-in-out'
                ),
                transform: `translateY(${carouselFocused ? '-726px' : '0'})`,
                visibility: vppaModalInfo,
              }}
            >
              <div className="header">
                <LogoHeader />
                <div
                  className="video-image"
                  style={{
                    backgroundImage: `url(${stripHttpProtocol(
                      assetMezzanine
                    )}?crop=830x466&format=webp)`,
                  }}
                >
                  <div
                    className="video-player-image-preload"
                    style={{
                      backgroundImage: `url(${stripHttpProtocol(
                        assetMezzanine
                      )}?crop=1920x1080&format=webp)`,
                    }}
                  />

                  {is_mvod && (
                    <div className="passport-triangle">
                      <img
                        className="passport-logo"
                        src={passportImg}
                        alt={'passport logo'}
                      />
                    </div>
                  )}
                  {(expired || availability === 'not_yet_available') && (
                    <div className="video-image-overlay">
                      {expired && (
                        <p className="video-image-message">
                          This video expired on{' '}
                          {`${
                            expire_date.getMonth() + 1
                          }/${expire_date.getDate()}/${expire_date.getFullYear()} `}
                        </p>
                      )}
                      {availability === 'not_yet_available' && (
                        <p className="video-image-message">
                          This video is not currently available.
                        </p>
                      )}
                    </div>
                  )}
                  {newSecondsWatched > 0 && (
                    <ProgressBar current={newSecondsWatched} total={duration} />
                  )}
                </div>
                <div className="video-information">
                  <div className="detail-item">
                    <h2 className="show-title">{showTitle}</h2>
                  </div>

                  <div className="detail-item">
                    <h3 className="video-title">
                      {truncate.apply(episodeTitle, [56])}
                    </h3>
                  </div>

                  <div className="detail-item">
                    <span className="detail-line-section">
                      {formattedOrdinals}
                    </span>
                    {duration && duration > 0 ? (
                      <>
                        <span className="divider">|</span>
                        <span className="detail-line-section">
                          {secondsToHms(duration)}
                        </span>
                      </>
                    ) : null}
                    {content_rating ? (
                      <>
                        <span className="divider">|</span>
                        <span className="detail-line-section">
                          {content_rating}
                        </span>
                      </>
                    ) : null}
                    {captionTracks && captionTracks[0] ? (
                      <>
                        <span className="divider">|</span>
                        <span className="closed-captions">cc</span>
                      </>
                    ) : null}
                  </div>
                  <div className="detail-item">
                    <Description
                      className="video-details-description"
                      parent={this}
                      componentType="descriptionText"
                      ref={this.setRefs(DESCRIPTION_TEXT)}
                    >
                      <span>
                        {truncate.apply(description_long, [100, true])}
                      </span>
                      <span className="more-text">
                        {addMore.apply(description_long, [100])}
                      </span>
                    </Description>
                  </div>
                  <div className="controls">
                    {buttons.map((button, i) => {
                      return (
                        <StdButton
                          id={'upsell' === button.type ? 'passport' : ''}
                          parent={this}
                          componentType={button.id}
                          label={button.label}
                          ref={this.setRefs(button.id)}
                          key={i}
                          onClick={button.onClick}
                          link={button.link}
                          to={button.url ? button.url : '/home'}
                          preventReadTextOnEvent={false}
                        >
                          {('play' === button.type ||
                            'resume' === button.type) && (
                            <>
                              <PlayButton height="40px" fill={'#fff'} />
                              <p className="sr-only">{button.type}</p>
                            </>
                          )}

                          {'upsell' === button.type && (
                            <Passport height="40px" fill={'#fff'} />
                          )}

                          {'in-watchlist' === button.type && (
                            <Checkmark height="40px" fill={'#fff'} />
                          )}

                          {'add-to-watchlist' === button.type && (
                            <Add height="40px" fill={'#fff'} />
                          )}
                          {'moreEpisodes' === button.type && (
                            <img
                              id="moreEpisodes"
                              src={MoreEpisodesImage}
                            ></img>
                          )}

                          {'preview' === button.type && (
                            <>
                              <Preview height="40px" fill={'#fff'} />
                              <p className="sr-only">{button.type}</p>
                            </>
                          )}
                        </StdButton>
                      )
                    })}
                  </div>
                </div>
              </div>
              {'undefined' !== typeof collections && (
                <CarouselList
                  collections={collections}
                  parent={this}
                  hideTitle={true}
                  hideMetaData={false}
                  ref={this.setRefs(CAROUSEL_LIST)}
                />
              )}
              <div>{funderMessage}</div>
            </div>
          </>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    upNextToggled: state.content.upNextVideoToggled,
    upNextContinueWatchingBackUrl: state.content.upNextContinueWatchingBackUrl,
    deviceModel: state.device.deviceModel,
    id: state.content.id,
    videoDetails: state.content.videoDetails,
    watchlist: state.personalization.watchlist,
    watchlistFullyLoaded: state.personalization.watchlistFullyLoaded,
    UID: state.device.UID,
    pid: state.user.pid,
    validPassport: state.user.validPassport,
    callSign: state.station.call_sign,
    stationShortCommonName: state.station.short_common_name,
    memberships: state.user.memberships,
    vppa_status: state.user.vppa_status,
    ui: state.ui,
    searchQuery: state.search.searchQuery,
    stationHasDonationCampaign:
      state.station.donation_campaign.station_has_donation_campaign,
    distributor: state.device.distributor,
    donationQueryParams: state.device.donationQueryParams,
  }
}

VideoDetailScreen.propTypes = {
  dispatch: PropTypes.func,
  id: PropTypes.string,
  UID: PropTypes.string,
  watchlist: PropTypes.array,
  watchlistFullyLoaded: PropTypes.bool,
  upNextVideoToggled: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  router: PropTypes.shape({
    navigate: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
      pathname: PropTypes.string,
      state: PropTypes.shape({
        fromVOD: PropTypes.bool,
        fromContinueWatchingModal: PropTypes.bool,
        fromUpNext: PropTypes.bool,
      }),
    }),
    params: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  videoDetails: PropTypes.shape({
    slug: PropTypes.string,
    videoId: PropTypes.string,
    contentType: PropTypes.string,
    contentUrl: PropTypes.string,
    parent: PropTypes.any,
    assetMezzanine: PropTypes.string,
    captionTracks: PropTypes.array,
    collections: PropTypes.any,
    content_rating: PropTypes.string,
    description_long: PropTypes.string,
    duration: PropTypes.number,
    episodeTitle: PropTypes.string,
    expire_date: PropTypes.any,
    expired: PropTypes.bool,
    formattedOrdinals: PropTypes.string,
    funderMessage: PropTypes.string,
    hasRelated: PropTypes.bool,
    is_mvod: PropTypes.bool,
    isPlayable: PropTypes.bool,
    parentShowSlug: PropTypes.string,
    relatedAssetUrl: PropTypes.string,
    relatedAssetVideoType: PropTypes.string,
    seconds_watched: PropTypes.number,
    showTitle: PropTypes.string,
    url: PropTypes.string,
  }),
  upNextToggled: PropTypes.bool,
  upNextContinueWatchingBackUrl: PropTypes.string,
  deviceModel: PropTypes.string,
  pid: PropTypes.string,
  validPassport: PropTypes.bool,
  callSign: PropTypes.string,
  stationShortCommonName: PropTypes.string,
  memberships: PropTypes.array,
  vppa_status: PropTypes.string,
  ui: PropTypes.shape({
    focusedComponent: PropTypes.string,
  }),
  searchQuery: PropTypes.string,
  stationHasDonationCampaign: PropTypes.bool,
  distributor: PropTypes.string,
  donationQueryParams: PropTypes.string,
}

export default connect(
  mapStateToProps,
  null,
  null
)(withRouter(focusable(VideoDetailScreen)))
